import { Box } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

import EngineSVG from "../../icons/MechanicalReportIcons/EngineSVG";
import TransmissionSVG from "../../icons/MechanicalReportIcons/TransmissionSVG";
import FluidSVG from "../../icons/MechanicalReportIcons/FluidSVG";
import LightSVG from "../../icons/MechanicalReportIcons/LightSVG";
import TyreSVG from "../../icons/MechanicalReportIcons/TyreSVG";
import OtherSVG from "../../icons/MechanicalReportIcons/OtherSVG";
import ReportBadge from "./ReportBadge";

const StyledReportItem = styled(Box)<{
  shouldStack: boolean;
  hasAmber: boolean;
  hasRed: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => (props.shouldStack ? "column" : "row")};

  .amber {
    margin-bottom: ${(props) =>
      props.shouldStack && props.hasRed ? "0px" : "-2px"};
    margin-left: -8px;
  }

  .red {
    margin-bottom: ${(props) =>
      props.shouldStack && props.hasAmber ? "-4px" : "-2px"};
    margin-left: ${(props) => (props.shouldStack ? "-8px" : "-4px")};
  }
`;

interface ReportItemProps {
  categoryKey: string;
  severityCode: string;
  numberOfAmber: number;
  numberOfRed: number;
}

enum SeverityCode {
  GREEN = "GREEN",
  AMBER = "AMBER",
  RED = "RED",
}

const ReportItem: React.FunctionComponent<ReportItemProps> = ({
  categoryKey,
  severityCode,
  numberOfAmber,
  numberOfRed,
}) => {
  const reportIcon = {
    Engine: {
      icon: <EngineSVG />,
    },
    Gearbox: {
      icon: <TransmissionSVG />,
    },
    Fluids: {
      icon: <FluidSVG />,
    },
    WarningLights: {
      icon: <LightSVG />,
    },
    Other: {
      icon: <OtherSVG />,
    },
    "Wheel&Tyres": {
      icon: <TyreSVG />,
    },
  };

  const getReportBadges = () => {
    if (severityCode === SeverityCode.GREEN) {
      return <ReportBadge severityCode={SeverityCode.GREEN} />;
    }

    return (
      <StyledReportItem
        shouldStack={true}
        hasAmber={Boolean(numberOfAmber)}
        hasRed={Boolean(numberOfRed)}
      >
        {numberOfAmber ? (
          <ReportBadge
            severityCode={SeverityCode.AMBER}
            numberOfItems={numberOfAmber}
            className="amber"
          />
        ) : null}
        {numberOfRed ? (
          <ReportBadge
            severityCode={SeverityCode.RED}
            numberOfItems={numberOfRed}
            className="red"
          />
        ) : null}
      </StyledReportItem>
    );
  };

  return (
    <Box display="flex" alignItems="end" minWidth="30px" maxHeight="24px">
      {reportIcon[categoryKey].icon}
      {getReportBadges()}
    </Box>
  );
};

export default ReportItem;
